<script>
export default {
  data() {
    return {
      webUrl: process.env.VUE_APP_BASE_URL_WEB
    }
  }
}
</script>
<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex ml-5">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <img id="logo" src="@/assets/images/front-logo.png" alt />
        </div>
      </div>

      <div class="d-flex align-items-center mr-5">
        <a :href="webUrl" class="text-decoration-none mr-2">
          <strong>
            <img id="back" src="@/assets/images/right.png" alt />
            Kembali Ke Beranda
          </strong>
        </a>
        <button v-if="this.$route.name == 'register'" type="button" @click="$router.push('/login')" class="text-decoration-none btn btn-danger ml-2">
          Log In
        </button>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
header {
  .navbar-header {
    background-color: #fff !important;
    color: #f01b3c !important;
  }

  .navbar-brand-box {
    background-color: #fff !important;
  }

  button {
    background-color: #f01b3c !important;
    color: #fff !important;
  }

  a {
    color: #f01b3c !important;
  }
}
#logo {
  width: 80px;
}
#back {
  width: 25px;
}
</style>